import { useState, useEffect } from 'react'

const STORAGE_KEY = 'binance-favorites'

export function useBinanceFavorites() {
  const [favorites, setFavorites] = useState<string[]>(() => {
    // Initialize from localStorage if available
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (stored) {
        try {
          return JSON.parse(stored)
        } catch (e) {
          console.error('Error parsing stored favorites:', e)
        }
      }
    }
    // Default favorites if nothing in localStorage
    return [
      'BTCUSDT',
      'ETHUSDT',
      'BNBUSDT',
      'SOLUSDT',
      'DOGEUSDT',
      'XRPUSDT',
      'DOTUSDT',
      'UNIUSDT',
      'LTCUSDT',
      'LINKUSDT'
    ]
  })

  // Save to localStorage whenever favorites change
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites))
    }
  }, [favorites])

  const addFavorite = (symbol: string) => {
    const formattedSymbol = symbol.toUpperCase()
    if (!favorites.includes(formattedSymbol)) {
      setFavorites([...favorites, formattedSymbol])
      return true
    }
    return false
  }

  const removeFavorite = (symbol: string) => {
    const formattedSymbol = symbol.toUpperCase()
    if (favorites.includes(formattedSymbol)) {
      setFavorites(favorites.filter(fav => fav !== formattedSymbol))
      return true
    }
    return false
  }

  const toggleFavorite = (symbol: string) => {
    const formattedSymbol = symbol.toUpperCase()
    if (favorites.includes(formattedSymbol)) {
      removeFavorite(formattedSymbol)
      return false // Indicates it was removed
    } else {
      addFavorite(formattedSymbol)
      return true // Indicates it was added
    }
  }

  const isFavorite = (symbol: string) => {
    return favorites.includes(symbol.toUpperCase())
  }

  return {
    favorites,
    addFavorite,
    removeFavorite,
    toggleFavorite,
    isFavorite
  }
}
